// extracted by mini-css-extract-plugin
export default {"declaration-domain-international":"Print_declaration-domain-international__cnyls","title-mini":"Print_title-mini__CQjsx"};